/**************************************************
 * Nombre:       Formulario_Contactanos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {React} from 'react';
import {Grid} from "@mui/material";
import {FormBase} from "../../Modulo_Formularios/ComponentesBase/C_Forms";
import {Building, Message, Mobile, User} from "iconsax-react";


const Formulario_Contactanos = (props) => {

    return (
        <FormBase {...props} >
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2}
            >


                <Grid item lg={6} sm={12} xs={12}>
                    <FormBase.InputIcon Icono={User} label={'Nombre'} dato={'nombre'}/>
                </Grid>

                <Grid item lg={6} sm={12} xs={12}>
                    <FormBase.InputIcon Icono={Mobile} label={'WhatsApp'} dato={'wass'}/>
                </Grid>

                <Grid item lg={12} sm={12} xs={12}>
                    <FormBase.InputIcon Icono={Building} label={'Correo'} dato={'correo'}/>
                </Grid>

                <Grid item lg={12} sm={12} xs={12}>
                    <FormBase.InputIcon Icono={Message} label={'mensaje'} dato={'mensaje'} lineas={3}/>
                </Grid>

            </Grid>
        </FormBase>
    )
}

export default Formulario_Contactanos;